export enum MenuType {
  MAIN_MENU,
  USER_SETTINGS_MENU,
}
